import React from 'react';
import { Link } from 'react-router-dom';
import { PageHero } from '../PublicLayout';
import { PLUS_BENEFITS } from '../content';

function PlanCard({ name, fee, highlight, points, ctaLabel, ctaTo }) {
  return (
    <div className={`rounded-[1.75rem] border p-7 flex flex-col ${highlight ? 'border-emerald-500/40 bg-emerald-500/[0.06]' : 'border-white/10 bg-white/[0.03]'}`}>
      <p className={`text-[11px] font-black uppercase tracking-[0.28em] mb-2 ${highlight ? 'text-emerald-400' : 'text-gray-500'}`}>{name}</p>
      <p className="text-3xl font-black text-white mb-1">{fee}</p>
      <p className="text-xs text-gray-500 font-bold mb-6">platform service fee on challenge earnings</p>
      <ul className="space-y-2.5 mb-7 flex-1">
        {points.map((p) => (
          <li key={p} className="text-sm text-gray-300 font-medium flex items-start gap-2">
            <span className="text-emerald-400 font-black mt-0.5">✓</span>
            {p}
          </li>
        ))}
      </ul>
      <Link
        to={ctaTo}
        className={`text-center px-6 py-3.5 rounded-2xl text-sm font-black uppercase tracking-[0.2em] transition-all ${
          highlight ? 'bg-emerald-500 hover:bg-emerald-400 text-black' : 'border border-white/15 text-white hover:bg-white/5'
        }`}
      >
        {ctaLabel}
      </Link>
    </div>
  );
}

export default function PlusPage() {
  return (
    <>
      <PageHero
        eyebrow="Membership"
        title="LockedIn Plus"
        subtitle="Keep more of what you win and unlock premium tools. Your subscription is separate from your wallet balance."
      />
      <section className="max-w-4xl mx-auto px-4 sm:px-6 pb-10">
        <div className="grid sm:grid-cols-2 gap-5">
          <PlanCard
            name="Free"
            fee="5%"
            points={['Browse and join challenges', 'Fund wallet & withdraw via Stripe', 'My Arena activity tracking', 'Standard platform features']}
            ctaLabel="Enter as Guest"
            ctaTo="/app"
          />
          <PlanCard
            name="LockedIn Plus"
            fee="2%"
            highlight
            points={PLUS_BENEFITS.map((b) => b.title)}
            ctaLabel="Create Account"
            ctaTo="/signup"
          />
        </div>
      </section>
      <section className="max-w-4xl mx-auto px-4 sm:px-6 py-10 border-t border-white/5">
        <div className="grid sm:grid-cols-2 gap-5">
          {PLUS_BENEFITS.map((b) => (
            <div key={b.title} className="rounded-2xl border border-white/10 bg-white/[0.03] p-6">
              <h3 className="text-base font-black uppercase tracking-tight text-white mb-2">{b.title}</h3>
              <p className="text-sm text-gray-400 leading-relaxed">{b.body}</p>
            </div>
          ))}
        </div>
        <p className="text-xs text-gray-600 font-medium text-center mt-8 max-w-xl mx-auto">
          The platform service fee is calculated by our servers at settlement based on the winner's active
          subscription. Wallet funds are used only for challenge entries and are never part of a subscription.
        </p>
      </section>
    </>
  );
}
